import styled from 'styled-components';

export const StyledPatientPrescriptionHistoryMinWidth = styled.div`
   min-width: 800px;
`;

StyledPatientPrescriptionHistoryMinWidth.displayName = 'StyledPatientPrescriptionHistoryMinWidth';
